import React from 'react'
import { Stack } from '@mui/system'
import { Typography } from '@mui/material'
import { J1RightarrowD, K1Information } from '@e3dc-react/icons'
import { InfoText } from '@e3dc-react/shell/Elements/InfoText'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useCategoryDisplayName } from 'src/Libs/downloads/hooks'
import { DownloadCategoryChildModel, DownloadsCategoryModel } from 'src/Libs/downloads/models'

const useStyles = makeStyles()(theme => ({
  emptyMessage: {
    justifyContent: 'center',
    my: theme.spacing(2),
  },
}))

interface Props {
  categories: (DownloadsCategoryModel | DownloadCategoryChildModel)[]
  onSelectCategory?: (category: DownloadsCategoryModel | DownloadCategoryChildModel) => void
}

const CategoryList: React.FC<Props> = ({ categories, onSelectCategory }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const getCategoryDisplayName = useCategoryDisplayName()

  if (categories.length === 0) {
    return <InfoText className={classes.emptyMessage} icon={<K1Information />} value={t('documents.edit-category.move.no-categories')} />
  }

  return (
    <Stack spacing={1}>
      {categories.map(category => (
        <Stack
          key={category.id}
          sx={theme => ({
            py: 1,
            px: 2,
            backgroundColor: theme.palette.grey.grey07,
            borderRadius: 1,
            border: '1px solid',
            borderColor: theme.palette.grey.grey06,
            cursor: onSelectCategory ? 'pointer' : 'default',
          })}
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          spacing={2}
          height={36}
          onClick={() => onSelectCategory?.(category)}
        >
          <Typography variant={'caption'}>{getCategoryDisplayName(category.nameLanguages)}</Typography>
          <J1RightarrowD />
        </Stack>
      ))}
    </Stack>
  )
}

export default CategoryList
